import React from 'react';

import styles from './style.module.scss';

export const Separator = () => {
  return <div className={styles.separator} />;
};
